"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEFAULT_OPTIONS = exports.ONE_MEGA_BYTE = exports.DEFAULT_MESSAGES = void 0;
exports.DEFAULT_MESSAGES = {
  // default screen
  orDropFile: 'or drop file to upload',
  dropFile: 'drop file to upload',
  uploadImage: 'Upload image',
  // image hints below the container
  fileHints: 'Only a .jpg or .png with a 16:9 aspect ratio.',
  maximumUploadSize: 'Maximum upload size',
  // errors
  generalError: 'Something went wrong.',
  maxSizeError: 'Your image exceeds the upload size limit.',
  minSizeError: 'Your image is below the minimum upload size.',
  tooManyFilesError: 'Your are uploading too many files.',
  fileTypeError: 'This file type is not supported.'
};
exports.ONE_MEGA_BYTE = 1024 * 1024;
exports.DEFAULT_OPTIONS = {
  accept: {
    'image/*': ['.jpeg', '.jpg', '.png']
  },
  maxSize: exports.ONE_MEGA_BYTE * 2,
  multiple: false,
  maxFiles: 1
};